import BaseApi from './BaseApi'

export default class DictionaryApi extends BaseApi {
    async getDictionaries (types = null) {
        let response = await this.get(`/api/v1.0/dictionaries`, {
            Types: types,
        })

        return response;
    }
}
